import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import moment from "moment";
import Box from '@material-ui/core/Box';
import { Form } from "reactstrap";
import Container from '@material-ui/core/Container';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import HomeIcon from '@material-ui/icons/Home';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
import 'tui-pagination/dist/tui-pagination.css';
import stylesCoup from '../../Shared/Css/Purchases/Purchas.module.css';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },

  root: {
    width: '18px',
    height: '18px',
    margin: '5px 0px 0px 0px',
    padding: '0px 0px 0px 5px',
  },
  // Applied to <FormControlLabel />
  label: {
    fontSize: 12,
    margin: '8px 0px 0px 0px',
    padding: '0px 0px 0px 5px',
    // border: '1px solid blue'
  },
}
));


function MaterialInputListSearch() {
  //사번복고화시작
  const [pwloading, setPwLoading] = useState(0); //실행시 한번만 권한가지기
  const [urlpw, setUrlpw] = useState(0); //실행시 매번 권한가져오기
  //사번복고화종료
  const gridRef = useRef();
  const [materialInputList, setMateriaInputList] = useState([]);
  const [materialInputListSelectData, setMaterialInputListSelectData] = useState([]);

  const [materialInputListGojangGubun, setMaterialInputListGojangGubun] = useState(''); //공장구분
  const [supplier, setSupplier] = useState(null); //업체명/코드
  const [materialInputListCode, setMaterialInputListCode] = useState(''); //자재규격
  const [materialInputListGubun, setMaterialInputListGubun] = useState(''); //자재구분
  const [materialInputListIpChulGubun, setMaterialInputListIpChulGubun] = useState('입고'); //자재입고출고 라디오버튼
  const [materialInputListNameChange, setMaterialInputListNameChange] = useState(''); //검색클릭값전달


  const [startDate, setStartDate] = useState(''); //검색시작날짜
  const [endDate, setEndDate] = useState(''); //검색끝날날짜
  const [groupby, setGroupby] = useState(); //집계방법(개별,그롭)

  const classes = useStyles();
  //히스토리사용
  const history = useHistory();

  const customRadio = <Radio size='small' color="primary" classes={{ root: classes.root }} />;


  //------------------------------------------------------세션복고화시작
  const pwBog = () => {
    const pwNo = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    //console.log(pwNo);
    pwNo > 0 ? setPwLoading(pwNo) : setPwLoading();
  }

  const pwLogin = () => {
    const pwNoPlus = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    setUrlpw(pwNoPlus)
  }

  useEffect(() => {
    pwBog()
    pwLogin()
    setStartDate(moment().startOf('month').format('YYYY-MM-DD')) //시작일자
    setEndDate(moment().endOf('month').format('YYYY-MM-DD'))   //끝날일자
    if (pwloading !== urlpw) {
      // window.location.href = '/AcountLogin/Login';
      window.location.assign('/AcountLogin/Login');
    }
    else {
    }
    // refreshPurchaseMaterialList()
  }, [pwloading, urlpw])

  // console.log(`초기값: ${pwloading}`)
  // console.log(`변경값:${urlpw}`)
  //-------------------------------------------------------사번복고화 종료;

  //select 리스트 가져오기
  useEffect(() => {
    axios.get('/api/PurchaseList/')
      .then((res) => {
        setMaterialInputListSelectData(res.data);
      })
  }, [])

  const haneleSuppilerOnClick = ((e) => {
    // setMaterialInputListNameChange('')
  })

  const materialInputListGongjangGubunHandle = ((e) => {
    // e.preventDefault()
    setMaterialInputListGojangGubun(e.target.value)
  })
  const haneleMaterialInputListCodeOnChange = ((e) => {
    // e.preventDefault()
    setMaterialInputListCode(e.target.value)
  })
  const haneleMaterialInputListCodeOnClick = ((e) => {
    // setMaterialInputListNameChange('')
  })

  const haneleMaterialInputListGubunOnChange = ((e) => {
    e.preventDefault()
    setMaterialInputListGubun(e.target.value)
  })

  const haneleMaterialInputListIpChulGubunOnChange = ((e) => {
    e.preventDefault()
    setMaterialInputListIpChulGubun(e.target.value)
  })

    //집계방법 변경했을때
    const materialInputListGroupbyGubunHandle = ((e) => {
      // e.preventDefault()
      setGroupby(e.target.value)
    })

  const haneleMaterialGubunOnClick = ((e) => {
    // setMaterialInputListNameChange('')
  })


  //검색클릭 값변경
  const handleMaterialInputListNameChange = (e) => {
    e.preventDefault();
    setMaterialInputListNameChange(e.target.value);
  };

  //검색엔트
  const handleMaterialInputListNameEnter = (e) => {
    e.preventDefault();
    if (materialInputListNameChange !== '' && e.key === 'Enter') {
      refreshMaterialList(); // null이 아니면 실행됨
    }
    else {
      setMateriaInputList([]);
    }
  };

  //폼전송버튼
  const handleFormSerche = (e) => {
    e.preventDefault();
    const evValue = new FormData(e.currentTarget);
    const DataSerche = {
      // s_Id: 30,
      공장구분: materialInputListGojangGubun ? materialInputListGojangGubun : null,   //공장구분
      업체코드: supplier.value ? supplier.value : null,   //업체코드
      자재규격: evValue.get("materialCode") ? evValue.get("materialCode") : null, //자재규격
      자재구분: evValue.get("materialGubun") ? evValue.get("materialGubun") : null, //자재구분
      시작일자: startDate ? startDate : null,   //자재입고시작일자
      끝날일자: endDate ? endDate : null,   //자재입고끝날일자
      합계선택: groupby ? groupby : '',   //합계선택 ,개별,규격,업체
      입고출고: materialInputListIpChulGubun,   //입고출고구분
    }
    // console.log(DataSerche)

    // const urlButtonSerche = `/api/PurchaseList/${DataSerche.s_업체코드}/${DataSerche.s_업체사업자번호}/${DataSerche.s_업체주소}`
    const urlButtonSerche = '/api/MaterialsInputList/Btnserche01/Btnserche02/'
    axios.get(urlButtonSerche, {
      params: {
        materialGojang: DataSerche.공장구분,
        materialUpcheCode: DataSerche.업체코드,
        materialCode: DataSerche.자재규격,
        materialGubun: DataSerche.자재구분,
        materialStartDate: DataSerche.시작일자,  //시작일자
        materialEndDate: DataSerche.끝날일자,       //끝날일자
        materialGroupby:DataSerche.합계선택,              //합계선택
        materialIpChulGubun: DataSerche.입고출고       //자재입고출고 구분
      }
    })
      .then((res) => {
        setMateriaInputList(res.data);
      })
  };

  const headers = useCallback(() => {
    return {
      'Content-type': `text/plain`,
    };
  }, []);

  const meterialAPI = useCallback(() => {
    const url = '/api/MaterialsInputList/';
    // const urlFileDown = '/api/VideosMyFileDown/';
    return {
      fetchAll: () => axios.get(url, { params: { materialInputName: materialInputListNameChange, materialStartDate: startDate, materialEndDate: endDate } }),
      create: (newRecord) =>
        axios.post(url, newRecord, { headers }).then((res) => {
          alert('정상적으로 저장되었습니다.');
          // console.log(res.data)
        }).catch(error => {
          alert("[규격[과 [업체명]이 동일할수가 없습니다[중복확인].")
          console.log(error);
        }),
      update: (id, updatedRecord) =>
        axios.put(url + id, updatedRecord).then((res) => {
          alert('정상적으로 수정되었습니다.');
        }).catch(error => {
          alert("수정이 안되고 있습니다[중복확인하시길 바랍니다].")
          console.log(error);
        }),
      delete: (id) => axios.delete(url + id).then((res) => {
        alert("정상적으로 삭제가 실행했습니다.")
      }).catch(error => {
        alert("삭제가 실패했습니다.")
        console.log(error);
      }),
      // download: (id) => axios.get(urlFileDown + id, { headers }),
    };
  }, [endDate, headers, materialInputListNameChange, startDate]);

  const refreshMaterialList = useCallback(async () => {
    await meterialAPI()
      .fetchAll()
      .then((res) => {
        setMateriaInputList(res.data);
      })
      .catch((err) => console.log(err));
  }, [meterialAPI]);


  //new Grid option 설정부분
  const columns = (
    [
      { name: "No", header: "No", align: "center", width: 'auto' },
      // {
      //   name: "edit", header: "수정", align: "center", width: 50,
      //   formatter: () => {
      //     return '<i class="fas fa-edit" style="font-size:16px;color:forestgreen;"></i>';
      //   }
      // },
      { name: "Id", header: "Id", align: "left", width: 50 },
      { name: "ms_공장구분", header: "공장", align: "center", width: 68 },
      { name: "ms_자재코드", header: "코드", align: "center", width: 55 },
      { name: "ms_자재품번", header: "품번", align: "left", width: 60 },
      { name: "ms_자재규격", header: "규격", align: "left", width: 212 },
      { name: "ms_단위량", header: "단위량", align: "center", width: 55 },
      { name: "ms_단위", header: "단위", align: "center", width: 50 },
      {
        name: "ms_자재단가", header: "단가", align: "right", width: 80,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "ms_수량", header: "입고량", align: "right", width: 70,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "ms_금액", header: "공급가액", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "ms_세액", header: "세액", align: "right", width: 65,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "계산서", header: "세금계산서", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "ms_입출일자", header: "입출일자", align: "center", width: 90,
        formatter: function (ev) {
          if (ev.value != "날짜빈값") {
           return `<div style="color:green;">${moment(ev.value, "YYYY-MM-DD a hh:mm").format('YYYY-MM-DD')}</div>`
          }
        }
      },
      { name: "ms_업체코드", header: "코드", align: "center", width: 50 },
      { name: "ms_업체명", header: "업체명", align: "left", width: 130 },
      { name: "ms_자재수불", header: "수불", align: "center", width: 70 },
      { name: "ms_자재구분", header: "공정", align: "center", width: 50 },
      { name: "ms_입고출고구분", header: "입출", align: "center", width: 50 },
      { name: "ms_자재설명", header: "Discription", align: "left", width: 125 },
      {
        name: "ms_결재지급금액", header: "지급액", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      { name: "ms_결재지급월", header: "월", align: "center", width: 60 },
      {
        name: "ms_결재유무", header: "결재", align: "center", width: 50,
        renderer: {
          styles: {
            // fontWeight: 'bold',
            fontSize: '12px',
            color: (props) => props.value === '미결' ? '#e57373' : props.value === '보류' ? 'LimeGreen' : props.value === '결재' ? '#388e3c' : props.value === '즉시' ? 'blue' : '#ccc'
          }
        }
      },
      // {
      //   name: 'ms_결재유무', header: "결재", align: "center", width: 50, // 전체칼럼 색상적용 css애 적요함. className: 'gross-color',
      //   copyOptions: {
      //     useListItemText: true
      //   },
      //   formatter: 'listItemText',
      //   editor: {
      //     type: 'text',
      //     options: {
      //       listItems: [
      //         { text: '<div style="color:red;">미결</div>', value: '미결' },
      //         { text: '<div style="color:LimeGreen">보류</div>', value: '보류' },
      //         { text: '<div style="color:blue; font-weight: 550;">지급</div>', value: '지급' },
      //       ]
      //     }
      //   }
      // },
      {
        name: "ms_결재지급일자", header: "지급일자", align: "center", width: 116,
        formatter: function (ev) {
          if (ev.value != "날짜빈값") {
            if (ev.value === null) {
              return ev.value === null ? "" : `${moment(ev.value).format('YYYY-MM-DD')}`
            }
            else {
              return ev.value === "" ? "" : `${moment(ev.value).format('YYYY-MM-DD')}`
            }
          } 
        }
      },
      {
        name: "미결금액", header: "미결금액", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      { name: "ms_계정과목코드", header: "코드", align: "center", width: 55 },
      { name: "ms_계정과목내용", header: "내용", align: "left", width: 77 },
      {
        name: "ms_등록일자", header: "등록일자", align: "center", width: 110,
        formatter: function (ev) {
          if (ev.value != "날짜빈값") {
          return `${moment(ev.value, "YYYY-MM-DD T hh:mm").format('YYYYMMDD HH:mm')}`
          }
        }
      },
      { name: "ms_등록자", header: "등록자", align: "center", width: 70 },
      // {
      //   name: "delete", header: "삭제", align: "center", width: 50,
      //   formatter: () => {
      //     return '<i class="fas fa-trash-alt" style="font-size:16px;color:red;"></i>';
      //   }
      // },
    ]
  );

  //번호, 체크박스 설정부분
  const rowHeaders = [
    // { type: 'rowNum' },
    //{type: 'checkbox'},
  ];

  const rows = materialInputList.map((row, index) => ({
    // id: row.id,
    No: index + 1,
    // edit: '수정',
    // print: '인쇄',
    Id: row.id,
    ms_공장구분: row.ms_공장구분,
    ms_자재코드: row.ms_자재코드,
    ms_자재품번: row.ms_자재품번 === 'null' ? '' : row.ms_자재품번,
    ms_자재규격: row.ms_자재규격,
    ms_단위: row.ms_단위,
    ms_단위량: row.ms_단위량,
    ms_자재단가: row.ms_자재단가 === 'null' ? '' : Number(row.ms_자재단가) ,
    ms_수량: Number(row.ms_수량),
    ms_금액: Number(row.ms_금액),
    ms_세액: Number(row.ms_세액),
    계산서: Number(row.ms_금액) + Number(row.ms_세액),
    ms_입출일자: row.ms_입출일자 === '0001-01-01' ? '0001-01-01' : row.ms_입출일자,
    ms_업체코드: row.ms_업체코드,
    ms_업체명: row.ms_업체명,
    ms_자재수불: row.ms_자재수불,
    ms_자재구분: row.ms_자재구분,
    ms_입고출고구분: row.ms_입고출고구분,
    ms_계정과목코드: row.ms_계정과목코드,
    ms_계정과목내용: row.ms_계정과목내용,
    ms_결재지급월: row.ms_결재지급월,
    ms_결재지급금액: Number(row.ms_결재지급금액),
    ms_결재유무: row.ms_결재유무,
    ms_결재지급일자: row.ms_결재지급일자 === '0001-01-01' ? '0001-01-01' : row.ms_결재지급일자,
    미결금액: (Number(row.ms_결재지급금액) - (Number(row.ms_금액) + Number(row.ms_세액))),
    ms_자재설명: row.ms_자재설명 === 'null' ? '' : row.ms_자재설명,
    ms_등록일자: row.ms_등록일자 === '0001-01-01' ? '0001-01-01' : row.ms_등록일자,
    ms_등록자: row.ms_등록자 === 'null' ? '' : row.ms_등록자,
    // delete: '삭제'
  }));

  //그리드 합계부분
  const summary = {
    height: 30,
    position: 'bottom', // or 'top'
    columnContent: {
      edit: {
        template(summary) {
          return '<div align="center">합계</div>';
        }
      },
      ms_자재단가: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      ms_수량: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      ms_금액: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      ms_세액: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      계산서: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      ms_결재지급금액: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      미결금액: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
    },
  };


  //혜더 복합칼럼설정
  const header = {
    height: 60,
    complexColumns: [
      {
        header: '구매자재정보',
        name: '구매자재정보',
        childNames: ['ms_자재코드', 'ms_자재품번', 'ms_자재규격']
      },
      {
        header: '구매자재[단위기준]',
        name: '구매자재[단위기준];',
        childNames: ['ms_단위', 'ms_단위량', 'ms_자재단가']
      },
      {
        header: '구매자재입고',
        name: '구매자재입고',
        childNames: ['ms_수량', 'ms_금액', 'ms_입출일자', 'ms_세액', '계산서']
      },
      {
        header: '구매자재업체',
        name: '구매자재업체',
        childNames: ['ms_업체코드', 'ms_업체명']
      },
      {
        header: '자재처리구분',
        name: '자재처리구분',
        childNames: ['ms_자재수불', 'ms_자재구분', 'ms_입고출고구분']
      },
      {
        header: '계정과목',
        name: '계정과목',
        childNames: ['ms_계정과목코드', 'ms_계정과목내용']
      },
      {
        header: '결재',
        name: '결재',
        childNames: ['ms_결재지급월', 'ms_결재지급금액', 'ms_결재유무', 'ms_결재지급일자', '미결금액']
      },
    ]
  }

  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    frozenBorder: {
      // border: 'pink',
      border: '#42a5f5',
    },
    outline: {
      // border: 'blue',
      border: '#59b9ea',
      showVerticalBorder: false, //수직선표시여부
    },
    cell: {
      normal: {
        background: 'pink',
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },

      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      rowHeader: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      selectedRowHead: {
        background: '#e5f6ff',
        showVerticalBorder: true
      },
      summary: {
        background: '#C0C0C0',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },

    area: {
      header: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      body: {
        border: 'red',
        background: 'white',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      summary: {
        border: '#59b9ea',
        background: 'pink',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //호버설정
    row: {
      hover: {
        background: 'silver'
      }
    },
  });

  //selectPicker 데이타뿌리기
  const selectData = materialInputListSelectData.map(
    item => ({ label: item.s_업체상호, value: item.s_업체코드 })
  );

  return (
    <>
      <div style={{ margin: '10px', textAlign: 'center' }}>
        <h3 style={{ color: "blue" }}>구매자재[입고출고]조회</h3>
      </div>
      <div className={stylesCoup.purchaseBox} >
        <div className={stylesCoup.purchasefind01}>
          <Form onSubmit={handleFormSerche}>
            <div className="input-group mb-12" >
              <FormControl
                variant="outlined"
                style={{ minWidth: 150, float: 'center', marginRight: '2px', }}
                size="small"
              >
                <InputLabel>공장</InputLabel>
                <Select
                  variant="outlined"
                  value={materialInputListGojangGubun ? materialInputListGojangGubun : ''}
                  onChange={materialInputListGongjangGubunHandle}
                  label="공장"
                >
                  <MenuItem value=""><div style={{ color: 'red' }}>값없음</div></MenuItem>
                  <MenuItem value={'정진P&G'}>정진P&G</MenuItem>
                  <MenuItem value={'(주)제이콥'}>(주)제이콥</MenuItem>
                </Select>
              </FormControl>
              <Autocomplete
                options={selectData}
                getOptionLabel={(option) => option.label || ''}
                size="small"
                style={{ width: 200, marginRight: 3 }}
                value={supplier ? supplier : setSupplier({ label: '', value: '' })}
                onChange={(event, newValue) => {
                  setSupplier(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="업체" variant="outlined" onClick={haneleSuppilerOnClick} />}
              />
              <TextField
                style={{ width: 150, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="구매자재규격"
                name="materialCode"
                value={materialInputListCode}
                autoComplete={materialInputListCode}
                onChange={haneleMaterialInputListCodeOnChange}
                onClick={haneleMaterialInputListCodeOnClick}
              />
              <TextField
                style={{ width: 150, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="자재처리공정"
                name="materialGubun"
                value={materialInputListGubun}
                autoComplete={materialInputListGubun}
                onChange={haneleMaterialInputListGubunOnChange}
                onClick={haneleMaterialGubunOnClick}
              />
              <TextField
                variant="outlined"
                size="small"
                style={{ width: 150, marginLeft: '0px', marginRight: "2px", float: "center" }}
                label="입출시작일자"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                variant="outlined"
                size="small"
                style={{ width: 150, marginLeft: '0px', marginRight: "2px", float: "center" }}
                label="입출끝날일자"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <FormControl
                variant="outlined"
                style={{ minWidth: 100, float: 'center', marginRight: '12px', }}
                size="small"
              >
                <InputLabel>집계방법</InputLabel>
                <Select
                  variant="outlined"
                  value={groupby ? groupby : ''}
                  onChange={materialInputListGroupbyGubunHandle}
                  label="집계방법"
                >
                  <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                  <MenuItem value={'개별'}>개별</MenuItem>
                  <MenuItem value={'규격'}>규격</MenuItem>
                  <MenuItem value={'업체'}>업체</MenuItem>
                </Select>
              </FormControl>
              <RadioGroup row value={materialInputListIpChulGubun} onChange={haneleMaterialInputListIpChulGubunOnChange} >
                <FormControlLabel labelPlacement='end' classes={{ label: classes.label }} control={customRadio} value="입고" label="입고" />
                <FormControlLabel labelPlacement='end' classes={{ label: classes.label }} control={customRadio} value="출고" label="출고" />
              </RadioGroup>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: '#0277bd',
                  color: 'white',
                  height: 36,
                  width: 110,
                  marginLeft: 0,
                  marginRight: 10,
                  float: "center",
                }}
              >
                <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '16px' }}></i>
                조회
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<HomeIcon />}
                style={{
                  background: '#004d40',
                  color: 'white',
                  height: 36,
                  width: 110,
                  float: "center",
                }}
                // onClick={() => {
                //   window.location.href = "/home/index";
                // }}
                onClick={() => { history.goBack(); }}  //이게 더빠름
              >
                홈이동
              </Button>
            </div>
          </Form>
        </div>
      </div>
      <div className={stylesCoup.purchasefind02} >
        <input className={`${stylesCoup.purchaseInput} ${stylesCoup.purchaseBox}`}
          placeholder="검색[Enter]"
          name="materialInputNameChange"
          value={materialInputListNameChange}
          onChange={handleMaterialInputListNameChange}
          onKeyUp={handleMaterialInputListNameEnter}
          // onClick={() => {
          //   if (materialInputListNameChange !== '' && supplier !== null && materialInputListCode !== null && materialInputListGubun !== null) {
          //     setMaterialInputListNameChange('');
          //     setSupplier('')
          //     setMaterialInputListCode('')
          //     setMaterialInputListGubun('')
          //   }
          // }}
        />
      </div>

      <Container maxWidth="xl" style={{ padding: '0px 20px 0px 20px' }}>
        <Box style={{ border: "1px solid", borderColor: "#42a5f5", borderRadius: "1px" }}>
          <Grid
            columns={columns}
            data={rows}
            header={header}
            summary={summary}
            scrollY={false}
            rowHeight={"auto"}
            minRowHeight={29}
            //bodyHeight={650}
            bodyHeight={"auto"}
            heightResizable={true}
            virtualScrolling={true}
            rowHeaders={rowHeaders}
            usageStatistics={false}
            pageOptions={{ useClient: true, perPage: 20 }}
            columnOptions={{
              minWidth: 50,
              frozenCount: 6,
              resizable: true,
            }}
            ref={gridRef}
          // onClick={handleEditClick}
          // onDblclick={handleEditDbClick}
          />
        </Box>
      </Container>
      {/* {materialInputListCreateModal === true ? <MaterialInputListCreate materialInputListCreateModal={materialInputListCreateModal} setMaterialInputListCreateModal={setMaterialInputListCreateModal}
        addOrEdit={addOrEdit} urlpw={urlpw} /> : null}

      {materialInputListEditModal === true ? <MaterialInputListEdit materialInputListEditModal={materialInputListEditModal} setMaterialInputListEditModal={setMaterialInputListEditModal}
        materialInputListEditValue={materialInputListEditValue} setMaterialInputListEditValue={materialInputListEditValue}
        addOrEdit={addOrEdit} urlpw={urlpw} /> : null}

      {materialInputListEditDbClickModal === true ? <MaterialInputListEditDbClick materialInputListEditDbClickModal={materialInputListEditDbClickModal} setMaterialInputListEditDbClickModal={setMaterialInputListEditDbClickModal}
        materialInputListEditValue={materialInputListEditValue} setMaterialInputListEditValue={materialInputListEditValue}
        addOrEdit={addOrEdit} urlpw={urlpw} /> : null}

      {materialInputListDeleteModal === true ? <MaterialInputListDelete materialInputListDeleteModal={materialInputListDeleteModal} setMaterialInputListDeleteModal={setMaterialInputListDeleteModal}
        materialInputListDeleteValue={materialInputListDeleteValue} setMaterialInputListDeleteValue={materialInputListDeleteValue}
        setMaterialInputListPasswordTrue={setMaterialInputListPasswordTrue}
        urlpw={urlpw} /> : null} */}
    </>
  )
}
export default MaterialInputListSearch